<template>
    <div>


        <CRow>
            <CCol sm="3" class="d-flex flex-column p-1">
                <CCard class="bg-gradient-blue p-3 text-white" style="border-radius:20px;border:none;flex-grow: 1;">
                    <p class="custom-20px-500">
                        Accuracy
                    </p>
                    <CCol sm="12">
                        <CRow>
                            <CCol sm="6">
                                <h3 class="custom-28px-600 text-white mt-4 custom-bottom-card" v-for="item in history.slice(0,1)" v-bind:key="item.Id">
                                    {{ item.final_accuracy }} %
                                </h3>
                            </CCol>
                            <CCol sm="6">
                                <div class="text-right">
                                    <img src="../assets/img/chart-blue.png" style="max-width:100%"/>
                                </div>
                            </CCol>
                        </CRow>
                    </CCol>
                </CCard>
            </CCol>
            <CCol sm="3" class="d-flex flex-column p-1">
                <CCard class="bg-white p-3" style="border-radius:20px;border:none;flex-grow: 1;">
                    <p class="custom-20px-500 font-color-101828">
                        Final Loss
                    </p>
                    <CCol sm="12">
                        <CRow>
                            <CCol sm="6">
                                <h3 class="custom-28px-600 mt-4 custom-bottom-card" v-for="item in history.slice(0,1)" v-bind:key="item.Id">
                                    {{ item.final_loss }} %
                                </h3>
                            </CCol>
                            <CCol sm="6">
                                <div class="text-right">
                                <img src="../assets/img/chart-white.png" style="max-width:100%"/>
                                </div>
                            </CCol>
                        </CRow>
                    </CCol>
                </CCard>
            </CCol>
            <CCol sm="3" class="d-flex flex-column p-1">
                <CCard class="bg-white p-3" style="border-radius:20px;border:none;flex-grow: 1;">
                    <p class="custom-20px-500 font-color-101828" style="white-space: nowrap;">
                        Count Detection
                    </p>
                    <CCol sm="12">
                        <CRow>
                            <CCol sm="6">
                                <h3 class="custom-28px-600 mt-4 custom-bottom-card" v-for="item in history.slice(0,1)" v-bind:key="item.Id">
                                    {{ item.count }} 
                                </h3>
                            </CCol>
                            <CCol sm="6">
                                <div class="text-right">
                                <img src="../assets/img/chart-blue.png" style="max-width:100%"/>
                                </div>
                            </CCol>
                        </CRow>
                    </CCol>
                </CCard>
            </CCol>
            <CCol sm="3" class="d-flex flex-column p-1">
                <CCard class="bg-white p-3" style="border-radius:20px;border:none;flex-grow: 1;">
                    <p class="custom-20px-500 font-color-101828">
                        Object Count
                    </p>
                    <CCol sm="12">
                        <CRow>
                            <CCol sm="6">
                                <h3 class="custom-28px-600 mt-4 custom-bottom-card">
                                    {{ totalGroupedObjects }} 
                                </h3>
                            </CCol>
                            <CCol sm="6">
                                <div class="text-right">
                                <img src="../assets/img/chart-blue.png" style="max-width:100%"/>
                                </div>
                            </CCol>
                        </CRow>
                    </CCol>
                </CCard>
            </CCol>
        </CRow>
        <!-- Main Layout -->
        <CRow>
            <!-- Column 1: Browse Image -->
            <CCol xs="12" sm="12" class="p-1" style="min-height: 100%;">
                <CCard class="p-4 border-19px d-flex flex-column" style="border:none; min-height: 100%;">
                    <CRow>
                        <CCol sm="12" class="p-0">
                            <h3 class="custom-14px-500 font-inter mt-2">Import from Youtube URL</h3>
                            <CInput type="text" v-model="videoLinkYoutube" placeholder="Enter YouTube video URL" @input="updatePreview"/>
                        </CCol>
                        <CCol sm="12" class="p-0">
                        <CCard class="bg-F9FAFB" style="max-height: 400px; overflow: hidden; border-radius: 20px;">
                            <div class="text-center mt-3">
                                <!-- YouTube Preview -->
                                <div v-if="!processedFrameSrc && videoLinkYoutube" id="preview">
                                    <iframe :src="embedYouTubeLink" 
                                            frameborder="0" 
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                            allowfullscreen 
                                            style="max-width: 100%; width: 100%; height: 400px">
                                    </iframe>
                                </div>

                                <!-- Video Thumbnail Preview -->
                                <div v-if="!processedFrameSrc && isVideo && urlThumbnail" id="preview">
                                    <video controls 
                                        :src="urlThumbnail" 
                                        class="border-16px" 
                                        style="max-width: 100%; max-height: 300px; object-fit: contain;">
                                    </video>
                                </div>

                                <!-- Image Thumbnail Preview -->
                                <div v-if="!processedFrameSrc && isImage && urlThumbnail" id="preview">
                                    <img :src="urlThumbnail" 
                                        alt="Image Preview" 
                                        class="image-preview border-16px" 
                                        style="max-width: 100%; max-height: 300px; object-fit: contain;" />
                                </div>

                                <!-- Processed Video -->
                                <div v-if="processedFrameSrc && isVideo">
                                    <video controls autoplay muted 
                                        :src="processedFrameSrc" 
                                        class="border-16px" 
                                        style="max-width: 100%; max-height: 300px; object-fit: contain;" 
                                        type="video/mp4">
                                    </video>
                                </div>

                                <!-- Processed YouTube Video -->
                                <div v-if="processedFrameSrc && videoLinkYoutube">
                                    <iframe :src="processedFrameSrc" 
                                            frameborder="0" 
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                            allowfullscreen 
                                            style="max-width: 100%; width: 100%; height: 400px;">
                                    </iframe>
                                </div>

                                <!-- Processed Image -->
                                <div v-if="processedFrameSrc && isImage">
                                    <img :src="processedFrameSrc" 
                                        alt="Processed Image" 
                                        class="image-preview border-16px" 
                                        style="max-width: 100%; max-height: 300px; object-fit: contain;" />
                                </div>

                                <!-- Default Placeholder Image -->
                                <img src="../assets/img/noimg.png" 
                                    width="100px" 
                                    style="margin-top:10%; object-fit: contain;" />

                                <!-- Info Text -->
                                <br />
                                <span class="font-color-696969">SVG, PNG, JPG, GIF, or MP4 (max. 800x400px)</span>
                                <br /><br /><br />
                            </div>
                        </CCard>
                    </CCol>
                        <CCol xs="12" sm="6">
                            <h3 class="custom-14px-500 font-inter">Browse Image/Video</h3>
                            <input type="file" id="thumbnail" ref="mythumbnail" @change="onFileChange" />
                        </CCol>
                        <CCol xs="12" sm="6">
                            <div class="text-right">
                                <input type="checkbox" v-model="poseCheckbox"> Apply POSE feature
                                <CButton type="button" class="bg-3A70EA text-white border-9px ml-2" @click="handleFileUpload">
                                    Analysis Object
                                </CButton>
                            </div>
                        </CCol>
                    </CRow>
                    <!-- Backdrop/Overlay when loading -->
                    <div v-if="isLoading" class="loading-backdrop">
                        <div class="text-center">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <p class="custom-20px-500 text-center text-white">Currently Analysis Images</p>
                            <p class="custom-14px-400 text-center text-white">
                                The system is processing images to improve model accuracy and performance.
                            </p>
                        </div>
                    </div>
                </CCard>
            </CCol>

            <CCol sm="6" class="p-1">
                <CCard 
                    class="p-4 border-19px hide-scroll" 
                    style="height: 400px; border-radius: 20px; border: none;">
                    <h3 class="custom-18px-500 font-color-101828 text-left">Analysis</h3>
                    <div v-for="(item, index) in history" :key="index">
                        <CRow class="mt-1">
                            <CCol md="1">
                                <img src="../assets/img/random/circlesmallblue.png" width="10px" />
                            </CCol>
                            <CCol md="11">
                                <p class="font-inter font-color-101828">
                                    Analysis the model for Image Detection was completed on {{ item.time }}.
                                    <br> Final Accuracy: {{ item.final_accuracy }}%
                                    <br> Final Loss: {{ item.final_loss }}
                                    <br> Detected Objects: {{ item.count }}
                                </p>
                                <label class="custom-14px-400 font-color-98A2B3">{{ item.relativeTime }}</label>
                            </CCol>
                            <CCol xs="12">
                                <hr class="custom-hr" />
                            </CCol>
                        </CRow>
                    </div>
                </CCard>
            </CCol>

            <CCol sm="6" class="p-1">
                <CCard 
                    class="p-4 border-19px hide-scroll" 
                    style="height: 400px; border-radius: 20px; border: none;">
                        <h3 class="custom-18px-500 font-color-101828 text-left">Top Categories Analysis</h3>

                        <div v-for="(item, historyIndex) in history.slice(0, 1)" :key="historyIndex" class="mt-3">
                                <div v-for="(group, groupIndex) in item.grouped_objects" :key="groupIndex">
                                    <CCol sm="12" class="p-0">
                                        <CRow class="d-flex align-items-center flex-nowrap">
                                            <CCol sm="4" class="">
                                                <h3 class="text-left ml-2 custom-16px-500" style="width:100%">{{ group.type }}</h3>
                                            </CCol>
                                            <CCol sm="6" class="flex-shrink-1">
                                                <div style="background:#F0F2F4;border-radius:22px">
                                                    <h3 
                                                        :class="[
                                                            getBackgroundClass(groupIndex),
                                                            'border-radius-half p-2 custom-16px-500 text-white'
                                                        ]"
                                                        :style="{
                                                            textAlign: 'center',
                                                            marginTop: '5px',
                                                            width: calculateWidth(group.count, item.grouped_objects) + '%'
                                                        }"
                                                    >
                                                    </h3>
                                                </div>
                                            </CCol>
                                            <CCol sm="2" class="flex-shrink-1">
                                                <h3 class="text-right mr-2 custom-16px-500">{{ group.count }}</h3>
                                            </CCol>
                                        </CRow>
                                    </CCol>
                                </div>
                            </div>
                        </CCard>
                    </CCol>
        </CRow>
        <br class="d-md-none d-lg-none" /><br class="d-md-none d-lg-none" />
       
    </div>
</template>

<script>
import { CChartLine } from '@coreui/vue-chartjs'
import { CChartBar } from '@coreui/vue-chartjs';
export default {
    components: {
        CChartLine,
        CChartBar,
    },
    data() {
        return {
            urlThumbnail: null, // URL for the preview image
            selectedImage: null, // Store the uploaded image file
            processedFrameSrc: null, // Placeholder for processed image
            isLoading: false, // Loading state to show spinner
            count: 0, // Current detected object count
            history: [], // Array to store detection history
            final_accuracy: "",
            final_loss: "",

            timeLabels: [],

            groupedObjects: [], // Initialize as an empty array
            labels: [],

            isImage: false,
            isVideo: false,
            processedFileSrc: null,
            selectedFile: null,
            videoSrc: "",
            videoLinkYoutube: "",
            embedYouTubeLink: "", 
            poseCheckbox: false,







        };
    },
    mounted: function() {
        this.videoSrc = "https://192.168.0.2:5040/processed_images/processed_79082469294649a7b80305751b209bfb.mp4";
    },
    computed: {
        totalGroupedObjects() {
            // Assuming history[0] contains the latest data
            const groupedObjects = this.history[0]?.grouped_objects || [];
            return groupedObjects.length; // Return the total count of grouped_objects
        },
        lineChartDatasets() {
            return [{
                label: 'Final Loss',
                backgroundColor: 'rgba(75, 192, 192, 0.2)', // Line color
                borderColor: 'rgba(75, 192, 192, 1)', // Line color
                borderWidth: 1,
                data: this.history.map(item => item.final_loss), // Extract final_loss from history
            }, ];
        },
        chartOptions() {
            return {
                responsive: true,
                scales: {
                    y: {
                        beginAtZero: true,
                        max: 1, // Assuming final_loss values range from 0 to 1 (adjust as needed)
                    },
                },
            };
        },
        lineChartDatasetsAccuracy() {
            return [{
                label: 'Final Accuracy',
                backgroundColor: 'rgba(75, 192, 192, 0.2)', // Line color
                borderColor: 'rgba(75, 192, 192, 1)', // Line color
                borderWidth: 1,
                data: this.history.map(item => item.final_accuracy), // Extract final_loss from history
            }, ];
        },
        lineChartDatasetsCount() {
            return [{
                label: 'Count Detection',
                backgroundColor: 'rgba(75, 192, 192, 0.2)', // Line color
                borderColor: 'rgba(75, 192, 192, 1)', // Line color
                borderWidth: 1,
                data: this.history.map(item => item.count), // Extract final_loss from history
            }, ];
        },
        computedDatasets() {
            return [{
                label: 'Object Count',
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                data: this.groupedObjects ? this.groupedObjects.map((obj) => obj.count) : [], // Extract counts
                borderWidth: 1,
            }];
        },
        // Chart options
        computedOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        beginAtZero: true, // Ensure the Y-axis starts at 0
                        ticks: {
                            padding: 10, // Add padding between tick values
                            stepSize: 2, // Set the spacing between ticks (optional)
                            callback: function(value, index, values) {
                                return value % 5 === 0 ? value : ''; // Show only values divisible by 5
                            },
                        },
                    },
                },
            };
        },
     

    },
   
    methods: {
        onFileChangeThumbnail(event) {
            this.processedFrameSrc = null;

            const file = event.target.files[0]; // Get the selected file from the event
            if (file) {
                this.urlThumbnail = URL.createObjectURL(file); // Set the image URL for preview
                this.selectedImage = file; // Store the selected image
                console.log("File selected:", file); // Check if file selection works
            } else {
                console.log("No file selected");
            }
        },
        updatePreview() {
        if (this.isYouTubeUrl(this.videoLinkYoutube)) {
            this.isImage = false;
    this.isVideo = false;
    this.selectedFile = null;
    this.urlThumbnail = '';
    this.processedFrameSrc = null; // Clear the processed frame source
    if (this.$refs.mythumbnail) {
        this.$refs.mythumbnail.value = ""; // Reset file input
    }
    console.log("test"+ this.convertToEmbedUrl(this.videoLinkYoutube));
            this.embedYouTubeLink = this.convertToEmbedUrl(this.videoLinkYoutube);
        } else {
            this.embedYouTubeLink = "";
        }
    },
    isYouTubeUrl(url) {
        const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|shorts\/|embed\/)|youtu\.be\/)[\w\-\?&=#]+$/;
        return youtubeRegex.test(url);
    },

    convertToEmbedUrl(url) {
        const videoId = this.extractVideoId(url);
        return `https://www.youtube.com/embed/${videoId}`;
    },

    extractVideoId(url) {
        const regExp = /(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w\-]+)/;
        const match = url.match(regExp);
        return match ? match[1] : "";
    },


        onFileChange(event) {
            this.processedFrameSrc = null;
            const file = event.target.files[0];
            if (file) {
                this.urlThumbnail = URL.createObjectURL(file);
                this.selectedFile = file;
                this.isImage = file.type.startsWith("image/");
                this.isVideo = file.type.startsWith("video/");
                this.videoLinkYoutube = "";
                console.log(`File type: ${file.type}`);
                console.log(`Is Image: ${this.isImage}, Is Video: ${this.isVideo}`);
            } else {
                console.log("No file selected");
            }
        },
        handleFileUpload() {
            // First, check if a valid YouTube URL has been entered

            // If no valid YouTube link, check for selected file
            if (!this.selectedFile && !this.videoLinkYoutube) {
                alert('Please select an image, video, or enter a valid YouTube URL.');
                return; // Exit if no file is selected or URL is entered
            }

            // Handle image upload
            if (this.isImage) {
                console.log("Uploading Image:", this.selectedFile);
                this.sendFrame(); // Call the function for image upload
            }
            // Handle video file upload
            else if (this.isVideo) {
                console.log("Uploading Video:", this.selectedFile);
                this.sendFrameVideo(); // Call the function for video file upload
               //this.sendFrameVideoAction();
            } else if (this.videoLinkYoutube) {
                console.log("Uploading Video:", this.videoLinkYoutube);
                this.sendFrameVideoYoutube(); // Call the function for video file upload
            } else {
                // Fallback if no valid image or video file selected
                alert('Invalid file type. Please select an image or video file.');
            }
        },
        sendLink() {
            this.sendFrameVideoYoutube();

        },

        sendFrame() {
            // Ensure the user has uploaded an image
            if (!this.selectedFile || !this.isImage) {
                console.log("No image selected");
                return; // Do nothing if no image is selected
            }

            // Set loading state to true to show the backdrop and spinner
            this.isLoading = true;

            // Create the FormData object
            const formData = new FormData();
            formData.append('file', this.selectedFile); // Append the selected image
            formData.append('include_pose', this.poseCheckbox); // Include pose checkbox status

            // Send the image to the server
            fetch('https://devai.mywire.org/idx_process_frame_category', { // Update with your Flask server URL
                method: 'POST',
                body: formData,
            })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Server responded with an error");
                }
                return response.json(); // Expecting a JSON response
            })
            .then((data) => {
                console.log("Server response received:", data);

                // Check if the expected data is present in the response
                const { file_url, count, final_accuracy, final_loss, grouped_objects, pose_data } = data;

                // If the response structure is not as expected, handle it gracefully
                if (!file_url || !grouped_objects) {
                    console.error("Incomplete response from server");
                    this.isLoading = false;
                    return; // Exit the function early if the response is incomplete
                }

                // Set the processed image source to the URL of the received image
                this.processedFrameSrc = file_url;

                // Get the current time
                const currentTime = new Date();
                const timeString = currentTime.toLocaleTimeString();

                // Calculate relative time
                let relativeTime = 'just now';
                if (this.history.length > 0) {
                    const lastUploadTime = this.history[0].time; // The time of the last upload
                    const lastUploadDate = new Date(lastUploadTime);
                    const timeDiffInMinutes = Math.floor((currentTime - lastUploadDate) / 60000); // Difference in minutes

                    if (timeDiffInMinutes >= 1) {
                        relativeTime = `${timeDiffInMinutes} minute${timeDiffInMinutes > 1 ? 's' : ''} ago`;
                    }
                }

                this.groupedObjects = grouped_objects;

                // Update labels for the bar chart
                this.labels = grouped_objects.map((obj) => obj.type);

                // Update the history array with the new data
                this.history.unshift({
                    count: count,
                    time: timeString,
                    final_accuracy: final_accuracy,
                    final_loss: final_loss,
                    relativeTime: relativeTime, // Set relative time based on the difference
                    grouped_objects: grouped_objects,
                    pose_data: pose_data, // Ensure pose_data is included in the history
                });

                // Update time labels for the chart
                this.timeLabels.unshift(timeString);

                // Log pose data if it's present
                if (this.poseCheckbox && pose_data) {
                    console.log('Pose data:', pose_data);  // Pose data from server
                }

                // Set loading state to false after the image is processed
                this.isLoading = false;
            })
            .catch((error) => {
                console.error("Error sending image:", error);
                // Ensure loading state is reset in case of error
                this.isLoading = false;
            });
        },
        // Function to display results in the UI

        beforeDestroy() {
            // Revoke the object URL if it exists to avoid memory leaks
            if (this.urlThumbnail) {
                URL.revokeObjectURL(this.urlThumbnail);
            }
        },
        sendFrameVideo() {
            if (!this.selectedFile || !this.isVideo) {
                console.log("No video selected");
                return;
            }

            this.isLoading = true;
            const formData = new FormData();
            formData.append('file', this.selectedFile);
            formData.append('include_pose', this.poseCheckbox); // Include pose checkbox status

            fetch('https://devai.mywire.org/process_video', {
                    method: 'POST',
                    body: formData,
                })
                .then((response) => response.json())
                .then((data) => {
                    console.log("Server response received:", data);

                    // Extract server response
                    const { file_url, count, final_accuracy, final_loss, grouped_objects } = data;
                    this.processedFrameSrc = file_url;
                    // Update processed video URL
                    const currentTime = new Date();
                    const timeString = currentTime.toLocaleTimeString();

                    // Calculate relative time
                    let relativeTime = 'just now';
                    if (this.history.length > 0) {
                        const lastUploadTime = this.history[0].time; // The time of the last upload
                        const lastUploadDate = new Date(lastUploadTime);
                        const timeDiffInMinutes = Math.floor((currentTime - lastUploadDate) / 60000); // Difference in minutes

                        if (timeDiffInMinutes >= 1) {
                            relativeTime = `${timeDiffInMinutes} minute${timeDiffInMinutes > 1 ? 's' : ''} ago`;
                        }
                    }


                   // this.groupedObjects = grouped_objects;

                    // Update labels for the bar chart
                   // this.labels = grouped_objects.map((obj) => obj.type);

                    if (this.history.length > 0) {
                        const lastUploadTime = this.history[0].time;
                        const lastUploadDate = new Date(lastUploadTime);
                        const timeDiffInMinutes = Math.floor((currentTime - lastUploadDate) / 60000);
                        if (timeDiffInMinutes >= 1) {
                            relativeTime = `${timeDiffInMinutes} minute${timeDiffInMinutes > 1 ? 's' : ''} ago`;
                        }
                    }

                    // Update the history array with the new data
                    this.history.unshift({
                        count: count,
                        time: timeString,
                        final_accuracy: final_accuracy,
                        final_loss: final_loss,
                        relativeTime: relativeTime, // Set relative time based on the difference
                        grouped_objects: grouped_objects
                    });

                    // Update time labels for the chart
                    this.timeLabels.unshift(timeString);

                    // Set loading state to false after the image is processed
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.error("Error sending video:", error);
                    alert("Failed to process video. Please try again.");
                    this.isLoading = false;
                });
        },
        sendFrameVideoYoutube() {
            this.isLoading = true;
            // fetch('https://cellnet.mywire.org/process_youtube_link', {
                fetch('https://cellnet.mywire.org/process_youtube_link', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        url: this.convertToEmbedUrl(this.videoLinkYoutube),
                        include_pose: this.poseCheckbox
                    })
                })


                .then((response) => response.json())
                .then((data) => {
                    console.log("Server response received:", data);

                    // Extract server response
                    const { file_url, count, final_accuracy, final_loss, grouped_objects } = data;
                    this.processedFrameSrc = file_url;

                    // Update processed video URL
                    const currentTime = new Date();
                    const timeString = currentTime.toLocaleTimeString();

                    // Calculate relative time
                    let relativeTime = 'just now';
                    if (this.history.length > 0) {
                        const lastUploadTime = this.history[0].time; // The time of the last upload
                        const lastUploadDate = new Date(lastUploadTime);
                        const timeDiffInMinutes = Math.floor((currentTime - lastUploadDate) / 60000); // Difference in minutes

                        if (timeDiffInMinutes >= 1) {
                            relativeTime = `${timeDiffInMinutes} minute${timeDiffInMinutes > 1 ? 's' : ''} ago`;
                        }
                    }


                    this.groupedObjects = grouped_objects;

                    // Update labels for the bar chart
                    this.labels = grouped_objects.map((obj) => obj.type);

                    if (this.history.length > 0) {
                        const lastUploadTime = this.history[0].time;
                        const lastUploadDate = new Date(lastUploadTime);
                        const timeDiffInMinutes = Math.floor((currentTime - lastUploadDate) / 60000);
                        if (timeDiffInMinutes >= 1) {
                            relativeTime = `${timeDiffInMinutes} minute${timeDiffInMinutes > 1 ? 's' : ''} ago`;
                        }
                    }

                    // Update the history array with the new data
                    this.history.unshift({
                        count: count,
                        time: timeString,
                        final_accuracy: final_accuracy,
                        final_loss: final_loss,
                        relativeTime: relativeTime, // Set relative time based on the difference
                        grouped_objects: grouped_objects
                    });

                    // Update time labels for the chart
                    this.timeLabels.unshift(timeString);

                    // Set loading state to false after the image is processed
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.error("Error sending video:", error);
                    alert("Failed to process video. Please try again.");
                    this.isLoading = false;
                });
        },
        onVideoCanPlay() {
            const videoElement = this.$refs.videoRef;

            // Check if the video is ready to play (it has enough data)
            if (videoElement.readyState >= 3) {
                // Video has enough data to play
                videoElement.play().catch(err => {
                    console.error("Error playing the video:", err);
                });
            } else {
                // Listen for the "canplay" event to ensure it's ready
                videoElement.addEventListener('canplay', () => {
                    videoElement.play().catch(err => {
                        console.error("Error playing the video:", err);
                    });
                });
            }
        },
        sendFrameVideoAction() {
            if (!this.selectedFile || !this.isVideo) {
                console.log("No video selected");
                return;
            }

            this.isLoading = true;
            const formData = new FormData();
            formData.append('file', this.selectedFile);

            fetch('http://192.168.0.8:5040/process_video_action', {
                method: 'POST',
                body: formData,
            })
            .then((response) => response.json())
            .then((data) => {
                console.log("Server response received:", data);

                // Extract server response
                const { file_url, count, final_accuracy, final_loss, grouped_objects } = data;

                // Update processed video URL
                this.processedFrameSrc = file_url;

                // Update history
                const currentTime = new Date();
                this.history.unshift({
                    count,
                    time: currentTime.toLocaleTimeString(),
                    final_accuracy,
                    final_loss,
                    relativeTime: "just now",
                });
                this.history = [...this.history]; // Ensures Vue reactivity

                // Update grouped objects and chart data
                this.groupedObjects = grouped_objects;
                this.labels = grouped_objects.map((obj) => `${obj.type} (${obj.action})`);

                // Force chart update if needed
                if (this.$refs.myChart) {
                    this.$refs.myChart.update();
                }

                this.isLoading = false;
            })
            .catch((error) => {
                console.error("Error sending video:", error);
                alert("Failed to process video. Please try again.");
                this.isLoading = false;
            });
        },
        getBackgroundClass(index) {
            const backgroundClasses = [
                'bg-6128D4',  // Index 0
                'bg-335CFF',  // Index 1
                'bg-FF5733',  // Index 2
                'bg-28A745',  // Index 3
            ];
            return backgroundClasses[index % backgroundClasses.length];
        },
        calculateWidth(count, groupedObjects) {
            const totalCount = groupedObjects.reduce((sum, obj) => sum + obj.count, 0);
            if (totalCount === 0) return 10; // Default to minimum width if no total count
            return (count / totalCount) * 100; // Adjust scale factor as needed
        }
    },

    mounted() {

    },

};
</script>

<style scoped>
/* Styling for the loading backdrop */

.loading-backdrop {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    /* Grey backdrop */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
    /* Ensure it sits on top of content */
    color: #fff;
    text-align: center;
}

/* Style for the spinner */

.spinner-border {
    width: 3rem;
    height: 3rem;
    border-width: 0.25em;
}

.spinner-border text-primary {
    color: #3A70EA;
    /* Adjust the spinner color */
}

.d-flex.align-items-stretch .CCol {
    display: flex;
    flex-direction: column;
    height: 100%;
}

/* Ensure CCard within columns stretches */

.CCol .CCard {
    flex: 1;
    /* Make CCard take up all available space */
}

.c-main {
    -ms-flex-preferred-size: auto;
    flex-basis: auto;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    min-width: 0;
    padding-top: 0rem;
}
</style>